import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsDateString,
  IsEnum,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  Length,
  ValidateNested
} from 'class-validator';
import { InvoiceBillingItemCreateDto } from './invoice-billing-item.create.dto';
import { InvoiceTypeEnum } from '../../enum/invoice-type.enum';
import { InvoiceOriginEnum } from '../../enum/invoice-origin.enum';
import { InvoiceFrequencyEnum } from '../../enum/invoice-frequency.enum';

export class InvoiceBillingCreateDto {
  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceName: string;

  @IsNotEmpty()
  @IsEnum(InvoiceTypeEnum, {
    message: `Invoice type must be one of the following values: ${Object.values(InvoiceTypeEnum).join(', ')}`,
  })
  invoiceType: InvoiceTypeEnum;

  @IsNotEmpty()
  @IsEnum(InvoiceOriginEnum, {
    message: `Invoice origin must be one of the following values: ${Object.values(InvoiceOriginEnum).join(', ')}`,
  })
  invoiceOrigin: InvoiceOriginEnum;

  @IsNotEmpty()
  @IsEnum(InvoiceFrequencyEnum, {
    message: `Invoice frequency must be one of the following values: ${Object.values(InvoiceFrequencyEnum).join(', ')}`,
  })
  invoiceFrequency: InvoiceFrequencyEnum;

  @IsNotEmpty()
  @IsInt()
  pieMerchantBusinessEntityId: number;

  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceToName: string;

  @IsOptional()
  @IsString()
  @Length(0, 150)
  invoiceToAddress?: string;

  @IsOptional()
  @IsString()
  @Length(0, 150)
  invoiceToVatNumber?: string;

  @IsOptional()
  @IsString()
  @Length(0, 150)
  invoiceToEmail?: string;

  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceFromName: string;

  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceFromAddress: string;

  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceFromVatNumber: string;

  @IsNotEmpty()
  @IsString()
  @Length(0, 150)
  invoiceFromEmail: string;

  @IsNotEmpty()
  @IsInt()
  pieCurrencyId: number;

  @IsNotEmpty()
  @IsString()
  @Length(0, 10)
  invoiceCurrencyCode: string;

  @IsNotEmpty()
  @IsDateString()
  billingStartDate: string;

  @IsNotEmpty()
  @IsDateString()
  invoiceDueDate: string;

  @IsNotEmpty()
  @IsNumber({maxDecimalPlaces: 2})
  invoiceVatAmount: number;

  @IsNotEmpty()
  @IsNumber({maxDecimalPlaces: 2})
  invoiceSubTotal: number;

  @IsOptional()
  @IsString()
  @Length(0, 250)
  invoiceNote?: string;

  @IsOptional()
  @IsString()
  @Length(0, 150)
  invoicePaymentLink?: string;

  @IsOptional()
  @IsString()
  @Length(0, 150)
  invoiceWebPaymentCode: string;

  @IsOptional()
  @IsInt()
  lastModifiedUserId?: number;

  @IsOptional()
  @IsBoolean()
  queueForDispatch?: boolean;

  @IsNotEmpty()
  @ValidateNested({each: true})
  @Type(() => InvoiceBillingItemCreateDto)
  invoiceItems: InvoiceBillingItemCreateDto[];
}